import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=5d1bf278"
import script from "./SinglePage.vue?vue&type=script&lang=js"
export * from "./SinglePage.vue?vue&type=script&lang=js"
import style0 from "./SinglePage.vue?vue&type=style&index=0&id=5d1bf278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports